export const AddToProject = ({
  primaryColor = 'var(--primary-bg-color)',
  secondColor = 'var(--primary-background-text-color',
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g
        id="Group_45106"
        data-name="Group 45106"
        transform="translate(-1622 -177)"
      >
        <g
          id="Group_45068"
          data-name="Group 45068"
          transform="translate(269 14)"
        >
          <g id="Group_43571" data-name="Group 43571">
            <circle
              id="Ellipse_1247"
              data-name="Ellipse 1247"
              cx="24"
              cy="24"
              r="24"
              transform="translate(1353 163)"
              fill={primaryColor}
            />
          </g>
        </g>
        <g id="add" transform="translate(1636.438 190.438)">
          <path
            id="Path_65950"
            data-name="Path 65950"
            d="M12.542,0H2.42A2.419,2.419,0,0,0,0,2.42V16.063a2.419,2.419,0,0,0,2.42,2.42h5.8a7.685,7.685,0,0,1-.739-3.3,7.607,7.607,0,0,1,.555-2.869.465.465,0,0,1-.114.009h-4.4a.88.88,0,0,1,0-1.76h4.4a.87.87,0,0,1,.775.475A7.769,7.769,0,0,1,10.879,8.8H3.521a.88.88,0,1,1,0-1.76h7.922a.883.883,0,0,1,.88.88.465.465,0,0,1-.009.114,7.376,7.376,0,0,1,2.649-.546V2.42A2.419,2.419,0,0,0,12.542,0Zm-5.5,5.281H3.521a.88.88,0,1,1,0-1.76H7.041a.88.88,0,0,1,0,1.76Z"
            fill={secondColor}
          />
          <path
            id="Path_65951"
            data-name="Path 65951"
            d="M16.441,10.5a5.941,5.941,0,1,0,5.941,5.941A5.948,5.948,0,0,0,16.441,10.5Zm2.42,6.821h-1.54v1.54a.88.88,0,0,1-1.76,0v-1.54h-1.54a.88.88,0,1,1,0-1.76h1.54v-1.54a.88.88,0,1,1,1.76,0v1.54h1.54a.88.88,0,0,1,0,1.76Z"
            transform="translate(-1.258 -1.258)"
            fill={secondColor}
          />
        </g>
      </g>
    </svg>
  );
};
